module.exports = __webpack_public_path__ + "img/q1.740d67bd.png";